module.exports = __webpack_public_path__ + "img/slide_3.e78e1f59.jpg";